export function formatRecord(wins, losses, ties) {
  return `${wins || 0}-${losses || 0}${ties ? `-${ties}` : ''}`;
}

/**
 * A probability as a whole percent, never rounding to a certainty it isn't:
 * ">99%" just under 100 and "<1%" just over 0.
 * @param {number} x
 * @returns {string}
 */
export const formatOdds = (x) => (x > 99.5 && x < 100 ? '>99%' : x > 0 && x < 0.5 ? '<1%' : `${Math.round(x)}%`);

/**
 * A signed decimal for outcome-flavoured numbers (luck, deltas): an explicit
 * "+" for positive, the proper minus glyph (U+2212, not a hyphen) for
 * negative, and a bare unsigned value at zero — mirrors LuckChart's local
 * `signed` helper, but drops LuckChart's "+0.0" in favour of a neutral "0.0"
 * since a zero delta reads as flat, not as a positive movement.
 * @param {number} value
 * @param {number} [decimals]
 * @returns {string}
 */
export function formatSigned(value, decimals = 1) {
  const rounded = Number(value.toFixed(decimals));
  if (rounded === 0) return rounded.toFixed(decimals);
  return `${rounded > 0 ? '+' : '−'}${Math.abs(rounded).toFixed(decimals)}`;
}

/**
 * Renders an ISO timestamp as a short "N ago" phrase for the header's
 * "synced N ago" clause. Returns null for a missing/unparseable timestamp
 * so callers can omit the clause entirely (e.g. while data is still loading).
 * @param {string | null | undefined} iso
 * @param {number} [now] - epoch ms, injectable for deterministic tests
 * @returns {string | null}
 */
export function relativeTime(iso, now = Date.now()) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;

  const minutes = Math.floor((now - then) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? '' : 's'} ago`;
}
